import React from "react";
import PropTypes from "prop-types";
import { LazyLoadImage } from "react-lazy-load-image-component";

function ArticleBoxThumbnail({
  imageUrl,
  userIconUrl,
  width,
  height,
  effect,
  showUserIconBackground = true,
}) {
  if (imageUrl) {
    return (
      <LazyLoadImage
        alt=""
        src={imageUrl}
        width={width}
        height={height}
        effect={effect}
      />
    );
  }

  if (userIconUrl) {
    const userIconStyle = { objectFit: "contain" };
    if (showUserIconBackground) {
      userIconStyle.background = "#cecece";
    }

    return (
      <LazyLoadImage
        alt=""
        src={userIconUrl}
        width={width}
        height={height}
        effect={effect}
        style={userIconStyle}
      />
    );
  }

  return <div className="p_defaultThumbnail" />;
}

ArticleBoxThumbnail.defaultProps = {
  imageUrl: undefined,
  userIconUrl: undefined,
  width: undefined,
  height: undefined,
  effect: undefined,
  showUserIconBackground: true,
};

ArticleBoxThumbnail.propTypes = {
  imageUrl: PropTypes.string,
  userIconUrl: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  effect: PropTypes.string,
  showUserIconBackground: PropTypes.bool,
};

export default ArticleBoxThumbnail;
